import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { AuthLayout } from '../../components/layouts';
import { LoginForm } from '../../components/auth';

function LoginPage() {
    const [isStoreManager, setIsStoreManager] = useState(false);

    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (searchParams.has('isStoreManager')) {
            setIsStoreManager(true);
        }
    }, [searchParams]);

    return (
        <AuthLayout>
            <LoginForm isStoreManager={isStoreManager} />
        </AuthLayout>
    );
}

export default LoginPage;
